export default __webpack_public_path__ + "static/media/(30).14a22358.jpeg";